import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import './extends/active.js';
import './extends/background.js';
import './extends/download.js';
import './extends/ordinals.js';
import './extends/external.js';
import './extends/a11y-patch.js';
import './extends/maintenance.js';
import './extends/text-wrap.js';


